import {
  getHomeConfig,
  getNoticeData,
  queryTokenList,
  getChains,
} from '@/services/home';
import { useHomeStore } from '@/store/home';

export const useBannerConfig = () => {
  const {
    setBanners,
    setActivities,
    setDapps,
    setNotices,
    setTokens,
    setChains,
  } = useHomeStore();

  const fetchBannerConfig = async () => {
    try {
      const { code, result } = await getHomeConfig();
      if (code === 0) {
        setBanners(result.bannerData || []);
        setActivities(result.activityModuleData || []);
        setDapps(result.dappModuleData || []);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchNoticeData = async () => {
    try {
      const { code, result } = await getNoticeData();
      // console.log('fetchNoticeData:', result);
      if (code === 0) {
        setNotices(result || []);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchHotCoins = async () => {
    try {
      const { code, result } = await queryTokenList({
        tag: 'hot',
        limit: 5,
      });
      // console.log('fetchHotCoins:', result);
      if (code === 0) {
        const list = (result || []).slice(0, 5);
        setTokens(list || []);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchChainList = async () => {
    try {
      const { code, result } = await getChains();
      if (code === 0) {
        setChains(result.walletChains.CLOUD.itemList);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const init = () => {
    fetchBannerConfig();
    fetchNoticeData();
    fetchHotCoins();
    fetchChainList();
  };

  return {
    fetchBannerConfig,
    fetchNoticeData,
    fetchHotCoins,
    fetchChainList,
    init,
  };
};
